<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.staff.preferredName')" prop="staffName">
            <BjInput v-model="queryParams.staffName" :placeholder="$t('AccountManagement.staff.preferredName')" @keyup.enter.native="handleQuery"/>
            <!-- <BjSelectLov v-model="queryParams.staffName" :option-list="staffNameList" :placeholder="$t('AccountManagement.staff.name')" @change="handleQuery" /> -->
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.staff.type')" prop="staffType">
            <BjSelectLov v-model="queryParams.staffType" :option-list="staffTypeList" :placeholder="$t('AccountManagement.staff.type')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.staff.department')" prop="staffDepartment">
            <BjSelectLov v-model="queryParams.staffDepartment" :option-list="staffDepartmentList" :clearable="!deptDis" :placeholder="$t('AccountManagement.staff.department')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.staff.role')" prop="staffRole">
            <BjSelectLov v-model="queryParams.staffRole" :option-list="staffRoleList" :placeholder="$t('AccountManagement.staff.role')" @change="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd()">{{ $t('addText') }}</el-button>
          <el-button v-if="havePermission" class="main-btn" @click="showDecryptDialog()">{{ $t('AccountManagement.staff.decryptRates') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="col.prop == 'staffType'">
                <span>{{ $t(staffTypeList.bjGet(scope.row[col.prop])) }}</span>
              </template>
              <template v-else-if="col.prop == 'staffDepartment'">
                <span>{{ $t(staffDepartmentList.bjGet(scope.row[col.prop])) }}</span>
              </template>
              <template v-else-if="col.prop == 'staffRole'">
                <span>{{ $t(staffRoleList.bjGet(scope.row[col.prop])) }}</span>
              </template>
              <template v-else-if="isHourlyRateProp(col.prop)">
                <span>{{ getHourlyRateCellText(scope.row, col.prop) }}</span>
              </template>
              <template v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <template>
                <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="delete-btn" @click="onDel(props.row)">{{ $t('delText') }}</el-button>
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="450px" :before-close="handleClose">
      <el-form ref="form" :model="form" label-position="top" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('AccountManagement.staff.legalName')" prop="legalName">
              <BjInput v-model="form.legalName" :placeholder="$t('AccountManagement.staff.legalName')"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('AccountManagement.staff.preferredName')" prop="staffName">
              <BjInput v-model="form.staffName" :placeholder="$t('AccountManagement.staff.preferredName')"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!-- <el-col :span="12">
            <el-form-item :label="$t('AccountManagement.staff.name')" prop="staffName">
              <BjInput v-model="form.staffName" :placeholder="$t('AccountManagement.staff.name')"/>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item :label="$t('AccountManagement.staff.type')" prop="staffType">
              <BjSelectLov v-model="form.staffType" :option-list="staffTypeList" :placeholder="$t('AccountManagement.staff.type')"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('AccountManagement.staff.department')" prop="staffDepartment">
              <BjSelectLov v-model="form.staffDepartment" :option-list="staffDepartmentList" :placeholder="$t('AccountManagement.staff.department')"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('AccountManagement.staff.role')" prop="staffRole">
              <BjSelectLov v-model="form.staffRole" :option-list="staffRoleList" :placeholder="$t('AccountManagement.staff.role')"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="havePermission" :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('AccountManagement.staff.hourlyRateWithLeave')" prop="hourlyRateWithLeaveCiphertext">
              <BjInputMoney v-if="formHourlyRateEditable" v-model="form.hourlyRateWithLeaveCiphertext" :min="0" :not-auto-zero="true" :placeholder="$t('AccountManagement.staff.hourlyRateWithLeave')" />
              <BjInput v-else v-model="form.hourlyRateWithLeaveCiphertext" disabled :placeholder="$t('AccountManagement.staff.hourlyRateWithLeave')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('AccountManagement.staff.regularHourlyRate')" prop="regularHourlyRateCiphertext">
              <BjInputMoney v-if="formHourlyRateEditable" v-model="form.regularHourlyRateCiphertext" :min="0" :not-auto-zero="true" :placeholder="$t('AccountManagement.staff.regularHourlyRate')" />
              <BjInput v-else v-model="form.regularHourlyRateCiphertext" disabled :placeholder="$t('AccountManagement.staff.regularHourlyRate')" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" :loading="saving" @click="onSave()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('AccountManagement.staff.decryptRates')" :visible.sync="decryptDialogVisible" width="600px" :before-close="handleDecryptClose">
      <el-form label-position="top">
        <el-form-item :label="$t('AccountManagement.staff.privateKey')">
          <el-input v-model="decryptForm.privateKey" type="textarea" :autosize="{ minRows: 8, maxRows: 12 }" :placeholder="$t('AccountManagement.staff.privateKeyPlaceholder')" />
        </el-form-item>
        <el-upload action="#" :auto-upload="false" :show-file-list="false" :on-change="handlePrivateKeyFileChange">
          <el-button>{{ $t('AccountManagement.staff.uploadPrivateKey') }}</el-button>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDecryptClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" :loading="decrypting" @click="onDecryptConfirm()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { funConfigApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';
import { decryptWithRsaPrivateKey, encryptWithRsaPublicKey, importPkcs1PrivateKey, importSshRsaPublicKey } from '@/utils/rsa-crypto';

const STAFF_HOURLY_RATE_PUBLIC_KEY = `---- BEGIN SSH2 PUBLIC KEY ----
Comment: "4096-bit RSA, converted by wx224@SELLOCP80 from OpenSSH"
AAAAB3NzaC1yc2EAAAADAQABAAACAQDTqx/pr9V40Sn5CT/3JRzQYoaFsR3W1fY91sqiJd
Yf54Is9N2d4oapBZOuIYAXj4CkQP6+FWl1liaZ7d9nfLAvTFyxIpu2HiMWwXtRvZPkTYXc
CwzFPHclxfMTfommMhjLWDBPh/j17O4aPwl2JawtVUc7NhvI76EEsWsp5R0SmKJgs++ev4
cubma6NuOqIYp+l/nd3PYe1kB145TpO4W9S+f+tKBWENoKOaYwXWJhdBeGJ5T1LyxLP2wm
pjbz54zBIn84qEs8c+CG5GAFNuPPiHzdxdX0F6zs+ho8DYt00mS1v6XJstza8xmcr+YBml
jHSoU0X0Afm/S5AbVi+3ISnHMoOb3xaj+wWxNPv1E/tj1/2BEllkmGj/DH2ZXiDZ9cj/aI
ajgXKDAHd1EU8vBv+ZSMHU7isP1w+vinSpe57SkIxZHOooiQnJG+TrrLSvXOf1KyvID9HG
w5L3fcZqcBQvONKeORqd67hv/iVqeozTtnj0QXhl4USzHqXBvBW7IQRJ8yo0qy+FIbskhu
rpIkM5haPcrn5fE4SmsV6dqFEMi6KBRKgF2P2YDx/p/BGcrQIs2DWe6m5+i76Blzn5ZyIq
dgBI7MXuWhTfOZwFX/lag6QeHQFplOl7pSTtGDZ8XQjiXCHPd913Dk2mfdP+vxBoXwWEe5
zWyS3A1qjazUkw==
---- END SSH2 PUBLIC KEY ----`;

const HOURLY_RATE_PROPS = ['hourlyRateWithLeaveCiphertext', 'regularHourlyRateCiphertext'];
const getDefaultForm = () => {
  return {
    id: null,
    staffName: null,
    staffType: null,
    staffDepartment: null,
    staffRole: null,
    hourlyRateWithLeaveCiphertext: null,
    regularHourlyRateCiphertext: null,
  };
};

export default {
  name: 'BusinessUserStaffManagement',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      selection: true,
      queryApi: funConfigApi.getWarehouseStaffList,
      queryParams: {
        staffName: null,
        staffType: null,
        staffDepartment: null,
        staffRole: null,
      },
      // 员工姓名下拉列表
      staffNameList:[],
      // 种类下拉列表
      staffTypeList:[
        {label: this.$t('AccountManagement.staff.Full'), value:'1'},
        {label: this.$t('AccountManagement.staff.Casual'), value:'2'},
        {label: this.$t('AccountManagement.staff.Hire'), value:'3'},
      ],
      // 部门下拉列表
      staffDepartmentList:[],
      // 部门下拉列表是否禁用
      deptDis:false,
      staffDepartmentDisvalue:null,
      // 工种下拉列表
      staffRoleList: [
        {label:'Forklift Driver',value:'1'},
        {label:'Inbound Supervisor',value:'2'},
        {label:'Receiver',value:'3'},
        {label:'Container Unpacker',value:'4'},
        {label:'Return Staff',value:'5'},
        {label:'Picker',value:'6'},
        {label:'Counterbalance Driver',value:'7'},
        {label:'Outbound Supervisor',value:'8'},
        {label:'Forklift Picker',value:'9'}
      ],
      // 弹窗相关数据
      dialogTitle:null,
      dialogFormVisible: false,
      form: getDefaultForm(),
      formHourlyRateEditable: true,
      saving: false,
      decryptDialogVisible: false,
      decrypting: false,
      decryptForm: {
        privateKey: '',
      },
      decryptedRateMap: {},
      rules: {
        legalName: [{ required: true, validator: this.validateLoginName, trigger: 'blur' }],
        staffName: [{ required: true, validator: this.validateLoginName, trigger: 'blur' }],
        staffType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        staffDepartment: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        staffRole: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        hourlyRateWithLeaveCiphertext: [{ required: true, validator: this.validateHourlyRate, trigger: 'blur' }],
        regularHourlyRateCiphertext: [{ required: true, validator: this.validateHourlyRate, trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.getStaffNameList();
    this.getStaffDeptPull();
  },
  computed: {
    permissionBtns() {
      return this.$store.getters.userPermissionBtns || [];
    },
    havePermission() {
      return this.permissionBtns.includes('BusinessStaffManagementButton'.toLocaleLowerCase());
    },
    labelList() {
      const columns = [
        { label: this.$t('AccountManagement.staff.preferredName'), prop: 'staffName', isCheck: true, disabled: false },
        { label: this.$t('AccountManagement.staff.type'), prop: 'staffType', isCheck: true, disabled: false },
        { label: this.$t('AccountManagement.staff.department'), prop: 'staffDepartment', isCheck: true, disabled: false },
        { label: this.$t('AccountManagement.staff.role'), prop: 'staffRole', isCheck: true, disabled: false },
      ];

      if (this.havePermission) {
        columns.push(
          { label: this.$t('AccountManagement.staff.hourlyRateWithLeave'), prop: 'hourlyRateWithLeaveCiphertext', isCheck: true, disabled: false },
          { label: this.$t('AccountManagement.staff.regularHourlyRate'), prop: 'regularHourlyRateCiphertext', isCheck: true, disabled: false },
        );
      }

      columns.push({ label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 160 });

      return columns;
    },
  },
  methods: {
    // 名称验证
    validateLoginName(rule, value, callback) {
      if (rule.required && (!value || value === 0)) {
        callback(new Error(this.$t('inputText')));
      } else {
        if (!/^[\u4e00-\u9fa5a-zA-Z0-9\s,.?!]{2,20}$/.test(value)) {
          callback(new Error(this.$t('formatErrorText')));
        } else {
          callback();
        }
      }
    },
    validateHourlyRate(rule, value, callback) {
      if (!this.formHourlyRateEditable) {
        callback();
        return;
      }
      if (rule.required && (value === null || value === undefined || value === '' || Number(value) === 0)) {
        callback(new Error(this.$t('emptyWarningText1')));
      } else {
        callback();
      }
    },
    isHourlyRateProp(prop) {
      return HOURLY_RATE_PROPS.includes(prop);
    },
    getRateRowKey(row) {
      return row.id || row.staffId || row.staffName;
    },
    getHourlyRateCellText(row, prop) {
      const rowKey = this.getRateRowKey(row);
      const decryptedRow = this.decryptedRateMap[rowKey];
      if (decryptedRow && Object.prototype.hasOwnProperty.call(decryptedRow, prop)) {
        return decryptedRow[prop];
      }
      return row[prop];
    },
    showDecryptDialog() {
      this.decryptDialogVisible = true;
    },
    handleDecryptClose() {
      this.decryptDialogVisible = false;
      this.decrypting = false;
      this.decryptForm.privateKey = '';
    },
    handlePrivateKeyFileChange(file) {
      const rawFile = file && file.raw;
      if (!rawFile) return;
      const reader = new FileReader();
      reader.onload = event => {
        this.decryptForm.privateKey = event.target.result;
      };
      reader.readAsText(rawFile);
    },
    async onDecryptConfirm() {
      if (!this.decryptForm.privateKey) {
        this.$message.warning(this.$t('AccountManagement.staff.privateKeyRequired'));
        return;
      }

      const tableData = (this.$refs.BjPage && this.$refs.BjPage.tableData) || [];
      if (!tableData.length) {
        this.$message.warning(this.$t('table.emptyText'));
        return;
      }

      this.decrypting = true;
      try {
        const privateKey = await importPkcs1PrivateKey(this.decryptForm.privateKey);
        const decryptedRateMap = Object.assign({}, this.decryptedRateMap);

        for (let i = 0; i < tableData.length; i++) {
          const row = tableData[i];
          const rowKey = this.getRateRowKey(row);
          const decryptedRow = {};
          for (let j = 0; j < HOURLY_RATE_PROPS.length; j++) {
            const prop = HOURLY_RATE_PROPS[j];
            decryptedRow[prop] = await decryptWithRsaPrivateKey(row[prop], privateKey);
          }
          decryptedRateMap[rowKey] = decryptedRow;
        }

        this.decryptedRateMap = decryptedRateMap;
        this.msgSuccess(this.$t('AccountManagement.staff.decryptSuccess'));
        this.handleDecryptClose();
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t('AccountManagement.staff.decryptFailed'));
      } finally {
        this.decrypting = false;
      }
    },
    // 获取员工姓名下拉列表数据
    getStaffNameList() {
      funConfigApi.getWarehouseStaffNamePull().then(res => {
        this.staffNameList = res.map(resp => {
          return {label: resp.staffName,value:resp.staffName }
        });
      });
    },
    // 获取部门下拉列表数据
    getStaffDeptPull() {
      // 获取部门下拉列表数据(部分)
      funConfigApi.getWarehouseStaffDeptPullKEY().then(resp => {
        if(resp.length > 0){
          this.deptDis = true
          this.staffDepartmentList = resp.map(item => {
            return {label: item.name,value:item.id }
          });
          this.queryParams.staffDepartment = resp[0].id
          this.staffDepartmentDisvalue = resp[0].id
          this.reFresh();
        }else{
          // 获取部门下拉列表数据(全部)
          funConfigApi.getWarehouseStaffDeptPull().then(res => {
            this.staffDepartmentList = res.map(item => {
              return {label: item.name,value:item.id }
            });
          });
          this.deptDis = false
          this.queryParams.staffDepartment = null
          this.staffDepartmentDisvalue = null
          this.reFresh();
        }
      });
    },
    onAdd(){
      this.dialogTitle = this.$t('addText')
      this.form = getDefaultForm();
      this.formHourlyRateEditable = true;
      this.dialogFormVisible = true;
    },
    onEdit(row){
      this.dialogTitle = this.$t('editText')
      this.form = JSON.parse(JSON.stringify(row));
      this.formHourlyRateEditable = true;
      HOURLY_RATE_PROPS.forEach(prop => {
        this.form[prop] = null;
      });
      this.dialogFormVisible = true;
    },
    // 保存弹窗数据 并 关闭编辑弹窗
    onSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const form = await this.getFormPayload();
          const request = !this.form.id ? funConfigApi.addWarehouseStaffList : funConfigApi.editWarehouseStaffList;
          const res = await request(form);
          if(!res.failed){
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.decryptedRateMap = {};
            this.handleClose()
            this.getStaffNameList();
            this.reFresh();
          }
        } catch (error) {
          console.error(error);
          this.$message.error(this.$t('AccountManagement.staff.encryptFailed'));
        } finally {
          this.saving = false;
        }
      })
    },
    async getFormPayload() {
      const form = JSON.parse(JSON.stringify(this.form));
      if (!this.havePermission) {
        delete form.hourlyRateWithLeaveCiphertext;
        delete form.regularHourlyRateCiphertext;
        return form;
      }

      if (this.formHourlyRateEditable) {
        const publicKey = await importSshRsaPublicKey(STAFF_HOURLY_RATE_PUBLIC_KEY);
        form.hourlyRateWithLeaveCiphertext = await encryptWithRsaPublicKey(form.hourlyRateWithLeaveCiphertext, publicKey);
        form.regularHourlyRateCiphertext = await encryptWithRsaPublicKey(form.regularHourlyRateCiphertext, publicKey);
      }

      return form;
    },
    /** 关闭弹窗 清空数据 */
    handleClose() {
      this.form = getDefaultForm();
      this.formHourlyRateEditable = true;
      this.$refs.form.resetFields();
      this.dialogFormVisible = false;
    },
    // 删除按钮
    onDel(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          funConfigApi.delWarehouseStaffList({staffId: row.id}).then(res => {
            if(!res.failed){
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          });
        })
        .catch(() => { });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      if(this.deptDis){
        this.queryParams.staffDepartment = this.staffDepartmentDisvalue
      }else{
        this.queryParams.staffDepartment = null
      }
      // this.queryParamsTime_expensePeriod = [];
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}

.ts-divider {
  padding: 5px 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
</style>
